/**
 * Shared Validators using Zod
 */
import { z } from "zod";
// ============================================
// ROUND EXPANDER VALIDATORS
// ============================================
export * from "./roundExpander.schema.js";
// ============================================
// SCRAPER CONFIG VALIDATORS
// ============================================
export * from "./scraperConfig.schema.js";
// ============================================
// VARIANT VALIDATORS
// ============================================
export * from "./variant.schema.js";
// ============================================
// BATCH IMPORT VALIDATORS
// ============================================
export * from "./batchImport.schema.js";
// ============================================
// ROLE VALIDATORS
// ============================================
export * from "./role.schema.js";
// ============================================
// AUTH VALIDATORS
// ============================================
export const loginSchema = z.object({
    username: z.string().min(3).max(50),
    password: z.string().min(8),
});
export const registerSchema = z.object({
    username: z.string().min(3).max(50),
    email: z.string().email(),
    password: z
        .string()
        .min(8)
        .regex(/[A-Z]/, "Password must contain at least one uppercase letter"),
});
export const createUserSchema = z.object({
    username: z.string().min(3).max(50),
    email: z.string().email(),
    password: z.string().min(8, "Password must be at least 8 characters"),
    role_id: z.number().optional(),
});
export const changePasswordSchema = z.object({
    currentPassword: z.string(),
    newPassword: z
        .string()
        .min(8)
        .regex(/[A-Z]/, "Password must contain at least one uppercase letter"),
});
// ============================================
// JOB VALIDATORS
// ============================================
export const jobSchema = z.object({
    search_url: z.string().url(),
    search_params: z.record(z.unknown()),
});
// ============================================
// ROUND CONFIG VALIDATORS
// ============================================
export const roundConfigSchema = z.object({
    config_name: z.string().min(1).max(200),
    config_data: z.record(z.unknown()), // JSON object
    is_active: z.boolean().optional(),
});
// ============================================
// BATCH LIST VALIDATORS
// ============================================
export const batchListSchema = z.object({
    name: z.string().min(1).max(200),
    description: z.string().max(1000).nullable().optional(),
});
// ============================================
// FAVORITE VALIDATORS
// ============================================
export * from "./favorite.schema.js";
export * from "./jobFavorite.schema.js";
// ============================================
// TAG VALIDATORS
// ============================================
export * from "./tag.schema.js";
// ============================================
// NOTE VALIDATORS
// ============================================
export * from "./note.schema.js";
// ============================================
// SHARE VALIDATORS
// ============================================
export * from "./share.schema.js";
// ============================================
// EXPORT VALIDATORS
// ============================================
export * from "./export.schema.js";
// ============================================
// SEARCH VALIDATORS
// ============================================
export * from "./search.schema.js";
// ============================================
// NOTIFICATION VALIDATORS
// ============================================
export * from "./notification.schema.js";
// ============================================
// PRICE STATS VALIDATORS
// ============================================
export * from "./priceStats.schema.js";
// ============================================
// EXTENSION VALIDATORS
// ============================================
export * from "./extension.schema.js";
// ============================================
// SITE CONFIG VALIDATORS
// ============================================
export * from "./siteConfig.schema.js";
export * from "./browserUpdate.schema.js";
//# sourceMappingURL=index.js.map